<!--
  详情页 - 回款单
  props:
    id: 详情id
  emit:
    openDetail: 打开详情页
 -->

<template>
  <div class="v-tabs notes-list cash-receipt" :class="{'cash-empty': tableData.length === 0}">
    <div class="empty" v-if="tableData.length === 0">
      <img src="../../../assets/imgs/empty.png" alt="">
      <h3 class="text">无回款单信息</h3>
    </div>
    <div class="head" v-else>
      <div class="total">
        <span :class="[item.attr]" v-for="item in summaryInfo">
          {{item.attrName}}: {{item.amount}} {{unit}}
        </span>
      </div>
    </div>
    <div class="content" ref="content" v-if="tableData.length > 0">
      <ul class="item-list">
        <li class="item" v-for="item in tableData" :class="{'hc-red': isRed || item.isRed}">
          <div class="date">{{formatTime(item.addTime)}}</div>
          <div class="order">
            <div class="border">
              <div class="chapter" v-if="item.isBad">
                <img src="../../../assets/imgs/bad.png"/>
              </div>
              <div class="chapter" v-else-if="item.isCancel">
                <img src="../../../assets/imgs/cancel.png"/>
              </div>
              <div class="header">
                <span class="tit">{{item.amount}} 元</span>
                <span class="tag" v-for="payMethod in item.payMethod" :class="payMethod.color">{{payMethod.text}}</span>
              </div>
              <ul class="content">
                <li class="item">
                  <span class="left">回款单编号:</span>
                  <span class="right">{{item.paymentSheetNo}}</span>
                </li>
                <li class="item">
                  <span class="left">归属人:</span>
                  <span class="right">{{item.belongerName}}</span>
                </li>
                <li class="item">
                  <span class="left">实际回款日期:</span>
                  <span class="right">{{item.paymentTime}}</span>
                </li>
                <li class="item">
                  <span class="left">备注:</span>
                  <span class="right">{{item.memo}}</span>
                </li>
                <li class="item" v-if="item.file && item.file.length">
                  <span class="left">文件:</span>
                  <span class="right">
                      <!-- 附件信息 -->
                      <attachment-preview :data="item.file"></attachment-preview>
                  </span>
                </li>
              </ul>
            </div>
            <el-button type="text" class="delete" @click="deleteCash(item.id)">删除</el-button>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
// import Vue from 'vue'
import * as api from 'src/api'
import * as utils from 'src/utils'
import { mapActions } from 'vuex'
import { Message, MessageBox } from 'element-ui'
import attachmentPreview from 'components/common/attachment-preview'

export default {
  props: {
    id: {
      type: Number
    }
  },
  data () {
    return {
      tableData: [],
      summaryInfo: '',  //  回款单头部各个回款总计
      unit: '元',
      isRed: false,
      isBad: false
    }
  },
  computed: {
  },
  created () {
    this.getList()
  },
  methods: {
    ...mapActions([
      'setSortObj'
    ]),
    getList () {
      let url = `/paymentApi/paymentSheetList.html`
      let params = {
        id: this.id
      }
      api.post(url, params, (data) => {
        this.totalAmount = data.totalAmount
        this.totalUnAmount = data.totalUnAmount
        this.tableData = data.result
        this.isRed = data.isRed
        this.isBad = data.isBad
        this.summaryInfo = data.summaryInfo
        this.unit = data.unit || '元'
      })
    },
    formatTime (time) {
      return utils.formatDate(time, 'datetime')
    },
    deleteCash (id) {
      MessageBox.confirm('确定删除该回款单吗?', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteItem(id)
      }).catch(() => {})
    },
    deleteItem (id) {
      let url = '/paymentSheetApi/delete.html'
      let params = {
        ids: [id]
      }
      api.post(url, params, (data) => {
        Message('删除成功')
        this.getList()
      })
    }
  },
  watch: {
  },
  components: {
    attachmentPreview
  }
}
</script>

<style lang="less" scoped>
  @import '../../../assets/less/variable.less';

  .cash-receipt {
    .red {
      color: @bg-red;
    }
    .orange {
      color: @bg-orange;
    }
    &.cash-empty {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }
    .empty {
      text-align: center;
      .text {
        margin-top: 30px;
      }
    }
    .content {
      .item-list {
        .item {
          .date {
            display: block;
            width: 100%;
          }
          .tit {
            color: @bg-orange;
            font-size: 18px;
            float: left;
          }
          &.hc-red {
            .tit {
              color: @bg-red;
            }
            .tag {
              background-color: #fe8282;
              color: #fff;
            }
          }
        }
      }

    }
    .order {
      display: flex !important;
      margin-left: 30px;
      margin-top: 20px;
      border: 0 !important;
      .delete {
        color:red;
        margin-left:20px;
      }
      .border {
        border:1px solid #e5ecf7;
        box-shadow:0 2px 4px 0 rgba(0,0,0,0.05);
        border-radius:2px;
        width:426px;
        .header {
          text-align: right;
          height: 46px;
          border-bottom:1px solid #e5ecf7;
          border-radius:2px;
          padding: 11px 15px 0;
          box-sizing: border-box;
          .tag {
            background-color: #95a8c2;
            display: inline-block;
            padding: 0 5px;
            margin-left: 8px;
            height: 18px;
            line-height: 18px;
            font-size: 12px;
            color: #fff;
            border-radius: 4px;
            border: 1px solid transparent;
            white-space: nowrap;
            &.red {
              background-color: #fe8282;
              color: #fff;
            }
          }
        }
        .content {
          padding: 16px 30px 12px 0;
          background: #f5f9ff;
          font-size:13px;
          color:#929292;
          .item {
            display: flex;
            padding: 0;
            margin-bottom: 10px;
          }
          .left {
            flex: 0 0 auto;
            display: inline-block;
            width: 110px;
            text-align: right;
          }
          .right {
            width: 280px;
            margin-left: 8px;
            word-wrap: break-word;
            .file {
              line-height: 18px; 
            }
          }
        }
      }
    }
  }
  .total span {
    margin-right: 14px;
    &.badDebAmount, &.redAmount {
      color: @bg-red;
    }
  }
  .chapter {
    width: 64px;
    height: 64px;
    position: absolute;
    right: 20px;
    top: 38px;
    img {
      width: 100%;
      height: 100%;
    }
  }
</style>

<style>
  /* 顶掉预览组件样式 */
  .item-list .right .file-content .file-info {
    margin: 0;
    padding: 0;
    border-top: 0;
  }
  .item-list .right .file-content .file-info .label {
    display: none;
  }
</style>




// WEBPACK FOOTER //
// cash-receipt.vue?030116d0